import { createFileRoute, notFound } from "@tanstack/react-router";
import { z } from "zod";

import { NotFoundFallback, RouteErrorFallback } from "@/components/error-message";
import { cardDetailQueryOptions } from "@/features/cards/lib/card-detail-queries";
import { requireSession } from "@/lib/auth-session";
import { seoHead } from "@/lib/seo";
import { getSiteUrl } from "@/lib/site-config";

export const Route = createFileRoute(
  "/_app/contribute_/card_/$cardSlug_/printing_/$printingId_/image",
)({
  validateSearch: z.object({
    side: z.preprocess((value) => (Number(value) === 2 ? 2 : undefined), z.literal(2).optional()),
  }),
  beforeLoad: async ({ location, context }) => {
    await requireSession({ context, location });
  },
  head: ({ params }) =>
    seoHead({
      siteUrl: getSiteUrl(),
      title: `Suggest an image for ${params.cardSlug}`,
      description: "Suggest a missing image for a Riftbound card printing on OpenRift.",
      path: `/contribute/card/${params.cardSlug}/printing/${params.printingId}/image`,
    }),
  loader: async ({ context, params }) => {
    const data = await context.queryClient.query({
      ...cardDetailQueryOptions(params.cardSlug),
      staleTime: "static",
    });
    if (!data.printings.some((p) => p.printingId === params.printingId)) {
      throw notFound();
    }
  },
  component: () => null,
  errorComponent: RouteErrorFallback,
  notFoundComponent: NotFoundFallback,
});
